<template>
  <div class="share">
    <!-- <img :src="inviteImgLink" alt="" style="width: 200px;height: 200px"> -->
    <div class="share-rewards-content-wrap" style="position: relative">
      <div class="top-info">
        <div class="num-box" style="">
          <div style="display: flex; align-items: center">
            <img class="num-img" src="@/assets/home/jinbi.png" alt="" />
            <span class="num-price" style="font-weight: 600">{{
              subRechaneg || "0.00"
            }}</span>
          </div>
          <div class="num-desc">次日 自动发放</div>
        </div>
        <div class="btn-box">
          <div
            class="btn-left-box"
            v-clipboard:copy="inviteLink"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            复制邀请链接
          </div>
          <div class="btn-right-box" @click="showShareQrcode = true">
            生成邀请二维码
          </div>
        </div>
        <div class="desc-box">
          <div class="desc-top">
            <div class="top-box">
              <span>下级{{ childNum }}人</span>
              <span style="color: #2684ff" @click="showDownUser = true"
                >查看</span
              >
            </div>
            <div class="top-box">
              <span>充值收益</span>
              <span>{{ commissionsRate }}%</span>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between">
            <div class="top-box">
              <span>流水收益</span>
              <span>{{ consumeList[vipLevel].share }}%</span>
            </div>
            <div class="top-box">
              <span>总充值</span>
              <span>{{ rechargePrice || 0 }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-tab-box">
        <div class="tab-filter-box">
          <div
            @click="changeType(0)"
            :class="[type == 0 ? 'sel' : '']"
            class="tab-item"
          >
            充值奖励
          </div>
          <div
            @click="changeType(1)"
            :class="[type == 1 ? 'sel' : '']"
            class="tab-item"
          >
            流水奖励
          </div>
        </div>
      </div>

      <div class="table-box">
        <div class="list-header">
          <div class="id" style="flex: 1">用户名</div>
          <div class="price-1" style="flex: 1">充值金额</div>
          <div class="price-1" style="flex: 1">奖励比例</div>
          <div class="price-2" style="flex: 1">奖励金额</div>
          <div class="time" style="flex: 1">奖励时间</div>
        </div>
        <div
          class="table-scroll-box"
          style="margin-bottom: 170px"
          @scroll="scrollEventFn"
        >
          <div class="td-item" v-for="(item, index) in lists" :key="index">
            <div class="id" style="flex: 1">{{ item.subordinateUserName }}</div>
            <div class="price-1" style="flex: 1">{{ item.rechargePrice }}</div>
            <div class="price-1" style="flex: 1">{{ item.commissions }}</div>
            <div class="price-1" style="flex: 1">{{ item.rebate }}</div>
            <div class="time" style="flex: 1">{{ item.createTime }}</div>
          </div>
          <div
            class="no-data"
            v-if="lists.length == 0"
            style="margin-top: 10vh"
          >
            <div class="empty-box-new"></div>
            <div class="tip-text">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 生成二维码弹框 -->
    <shareQrcode
      title="邀请二维码"
      :showModal="showShareQrcode"
      :url="inviteImgLink"
      @close="closeShareQrcode"
    >
    </shareQrcode>
    <!-- 直推用户弹框 -->
    <DownUser :showModal="showDownUser" @close="closeDownUser"></DownUser>
  </div>
</template>
<script>
import {
  userCreditsRecords,
  getUserInfo,
  getUserInfoDetail,
  getPromotionRecord,
} from "@/api/index";
import QRCode from "qrcode";
import shareQrcode from "@/components/common/modalShareQrcode.vue";
import DownUser from "@/components/common/modalDownUser.vue";
export default {
  components: {
    shareQrcode,
    DownUser,
  },
  data() {
    return {
      safe_top: 0,
      user: {
        level_info: {},
      },
      info: {},

      showShareRule: false,
      page: 1,
      limit: 30,
      isOver: false,

      type: 0,
      uid: "",
      share_link: "",
      share_qrcode: "",
      //   原本
      sylistPage: {
        page: 1,
        size: 20,
      },
      //   明日预计收益
      subRechaneg: null,
      sylistIsOver: "加载中",
      sylist: [],
      mycode: null,
      facode: null,
      faName: null,
      subordinateNumber: null,
      message: "Copy These Text",
      //   邀请链接
      inviteLink: "",
      showShareQrcode: false,
      inviteImgLink: "",
      showDownUser: false,
      lists: [],
      parentNickName: null, //父昵称
      childNum: null, //下级个数
      rechargePrice: null, //下级总充值
      commissionsRate: null, //充值收益
      turnoverRate: null, //流水收益
      consumeList: {
        0: {
          share: "0.00",
          consumption: "0.00",
        },
        1: {
          share: "2.20",
          consumption: "0.40",
        },
        2: {
          share: "2.40",
          consumption: "0.60",
        },
        3: {
          share: "2.60",
          consumption: "0.80",
        },
        4: {
          share: "2.80",
          consumption: "1.00",
        },
        5: {
          share: "3.00",
          consumption: "1.30",
        },
        6: {
          share: "3.50",
          consumption: "1.50",
        },
        7: {
          share: "3.80",
          consumption: "2.00",
        },
        8: {
          share: "4.00",
          consumption: "2.50",
        },
        9: {
          share: "4.30",
          consumption: "3.00",
        },
        10: {
          share: "4.50",
          consumption: "3.50",
        },
      },
      vipLevel: 0,
    };
  },
  methods: {
    copyInviteLink() {},
    openShareQrcode() {},
    openDownUser() {},
    openShareRule() {},
    changeType(index) {
      this.type = index;
      this.page = 1;
      this.isOver = false;
      this.lists = [];
      this.getDataLists();
    },
    openShareRule() {},
    // 关闭直推用户弹框
    closeDownUser() {
      this.showDownUser = false;
    },
    // 关闭邀请码弹框
    closeShareQrcode() {
      this.showShareQrcode = false;
    },
    // 获取推广数据
    getShareRewardsList() {
      userCreditsRecords(this.sylistPage.page, this.sylistPage.size).then(
        (res) => {
          if (this.sylistIsOver == "加载中") {
            let arr = res.data.data.details.records;

            this.subRechaneg = res.data.data.todayPredict;
            arr.forEach((item) => {
              const shotTime = item.createTime.split(" ")[0];
              item.createTime =
                shotTime.split("-")[1] + "-" + shotTime.split("-")[2];
            });
            this.sylist.push(...arr);
            if (res.data.data.details.records.length < this.sylistPage.size) {
              this.sylistIsOver = "暂无更多";
            }
          }
        }
      );
    },
    // 获取用户数据
    getUserData() {
      getUserInfo().then((res) => {
        this.mycode = res.data.data.invitationCode;
        this.facode = res.data.data.parentInvitationCode;
        this.subordinateNumber = res.data.data.subordinateNumber;
        this.vipLevel = res.data.data.vipLevel;
        // 根据当前的网址组合拼接成邀请链接
        this.inviteLink = window.location.origin + "?code=" + this.mycode;
        // 处理成图片
        QRCode.toDataURL(this.inviteLink, { type: "image/png" }, (err, url) => {
          this.inviteImgLink = url;
          if (err) throw err;
        });
      });
    },
    getUserInfoDetailData() {
      getUserInfoDetail().then((res) => {
        const data = res.data.data;
        this.parentNickName = data.parentNickName;
        this.childNum = data.childNum;
        this.rechargePrice = data.rechargePrice;
        this.commissionsRate = data.commissionsRate;
        this.turnoverRate = data.turnoverRate;
      });
    },
    onCopy(e) {
      this.$message({
        duration: 1000,
        message: "复制成功！",
        type: "success",
        customClass: "log_success",
      });
    },
    onError(e) {
      this.$soundPlay("opFail");
      this.$message({
        duration: 1000,
        message: "复制失败！",
        type: "warning",
        customClass: "log_warning",
      });
    },
    //
    getDataLists() {
      if (this.type == 0) {
        this.getPromotionRecordFn();
      } else {
        // this.getPromotionRecordFn
      }
    },
    // 获取充值奖励接口
    getPromotionRecordFn() {
      if (this.isOver) {
        this.$message({
          duration: 1000,
          message: "没有更多数据",
          type: "warning",
          customClass: "log_warning",
        });
        return;
      }
      const params = {
        pageNum: this.page,
        pageSize: this.limit,
      };
      getPromotionRecord(params).then((res) => {
        if (res.data.code == 200) {
          const newData = res.data.rows;
          if (newData.length < this.size) {
            this.isOver = true; // 没有更多的数据
          } else {
            this.page++; // 增加页码，准备下一次请求
          }
          // 将新数据追加到已有的列表中
          this.lists = [...this.lists, ...newData];
        } else {
          this.$message({
            duration: 1000,
            message: res.data.msg,
            type: "warning",
            customClass: "log_warning",
          });
        }
      });
    },
    scrollEventFn(e) {
      // console.log(e);
      this.event = e;
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight >=
        e.srcElement.scrollHeight
      ) {
        this.getDataLists();
      }
    },
    init() {
      this.getShareRewardsList();
      this.getUserData();
      this.getUserInfoDetailData();
      this.changeType(0);
    },
  },

  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.share-rewards-content-wrap {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  margin-bottom: 3.07 * 4.2px;
  padding: 0 3.81 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-bottom: 3.07vw;
    padding: 0 3.81vw;
  }

  @media only screen and (max-width: 375px) {
    overflow-y: auto;
  }
}

.share-rewards-content-wrap .top-info {
  height: 48.05 * 4.2px;
  background: url("../../assets/image3/share/shareBack.png") no-repeat 0 0;
  background-size: 100% 100%;
  margin: 5.95 * 4.2px 0;

  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  @media only screen and (max-width: 430px) {
    height: 48.05vw;
    margin: 5.95vw 0;
  }
}

.share-rewards-content-wrap .top-info .num-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8.1 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-top: 8.1vw;
  }
}

.share-rewards-content-wrap .top-info .num-img {
  height: 4.52 * 4.2px;
  width: auto;
  margin-right: 0.48 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 4.52vw;
    margin-right: 0.48vw;
  }
}

.share-rewards-content-wrap .top-info .num-price {
  font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
  font-weight: 400;
  font-size: 3.88 * 4.2px;
  color: #ffffff;

  @media only screen and (max-width: 430px) {
    font-size: 3.88vw;
  }
}

.share-rewards-content-wrap .top-info .num-desc {
  height: 2rem;
  line-height: 1.4rem;
  background: rgba(0, 74, 172, 0.48);
  border-radius: 8px;
  font-weight: 400;
  font-size: 2.86 * 4.2px;
  color: #cdd7e2;
  padding: 0.4rem;
  margin-left: 2.14 * 4.2px;
}

.share-rewards-content-wrap .top-info .btn-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2.62 * 4.2px 0 3.57 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin: 2.62vw 0 3.57vw;
  }
}

.share-rewards-content-wrap .top-info .btn-box .btn-left-box {
  width: 7.25rem;
  height: 2.37rem;
  line-height: 2.37rem;
  background: url("../../assets/image3/share/copyLinkBack.png") no-repeat 0 0;
  background-size: 100% 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  font-style: normal;
  text-transform: none;
  text-align: center;

  margin-right: 6.19 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-right: 6.19vw;
  }
}

.share-rewards-content-wrap .top-info .btn-box .btn-right-box {
  width: 7.25rem;
  height: 2.37rem;
  line-height: 2.37rem;
  background: url("../../assets/image3/share/generateBack.png") no-repeat 0 0;
  background-size: 100% 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 12px;
  font-style: normal;
  text-transform: none;
  text-align: center;
}

.share-rewards-content-wrap .top-info .desc-box {
  padding: 0 7.62 * 4.2px;
  font-weight: 400;
  font-size: 3.33 * 4.2px;
  color: rgba(255, 255, 255, 0.58);

  @media only screen and (max-width: 430px) {
    padding: 0 7.62vw;
    font-size: 3.33vw;
  }
}

.share-rewards-content-wrap .top-info .desc-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3.1 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-bottom: 3.1vw;
  }
}

.share-rewards-content-wrap .top-info .top-box {
  width: 40%;
  display: flex;
  justify-content: space-between;
}

.share-rewards-content-wrap .text-box {
  width: 100%;
  height: 8.13 * 4.2px;
  color: #c7d4ff;

  @media only screen and (max-width: 430px) {
    height: 8.13vw;
  }
}

.share-rewards-content-wrap .text-box .text1 {
  float: left;
  height: 8.13 * 4.2px;
  line-height: 9.6 * 4.2px;
  font-size: 4.4 * 4.2px;
  margin-left: 0.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 8.13vw;
    line-height: 9.6vw;
    font-size: 4.4vw;
    margin-left: 0.67vw;
  }
}

.share-rewards-content-wrap .text-box .text2 {
  float: right;
  height: 8.13 * 4.2px;
  line-height: 9.6 * 4.2px;
  font-size: 3.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 8.13vw;
    line-height: 9.6vw;
    font-size: 3.33vw;
  }
}

.share-rewards-content-wrap .opt-box {
  width: 94.67 * 4.2px;
  height: 22.53 * 4.2px;
  background: url("../../assets/images/top_bg.png") no-repeat 0 0;
  background-size: 94.67 * 4.2px 22.53 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  position: relative;
  overflow: hidden;

  @media only screen and (max-width: 430px) {
    width: 94.67vw;
    height: 22.53vw;
    background-size: 94.67vw 22.53vw;
  }
}

.share-rewards-content-wrap .opt-box .tip-text {
  width: 26.67 * 4.2px;
  height: 4 * 4.2px;
  line-height: 4 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  bottom: 0.67 * 4.2px;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  font-size: 2.27 * 4.2px;
  color: #c7d4ff;
  text-align: center;

  @media only screen and (max-width: 430px) {
    width: 26.67vw;
    height: 4vw;
    line-height: 4vw;
    bottom: 0.67vw;
    font-size: 2.27vw;
  }
}

.share-rewards-content-wrap .opt-box .copy-btn {
  width: 28.93 * 4.2px;
  height: 20.93 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 4.4 * 4.2px;
  margin-top: -1.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 4.4vw;
    margin-top: -1.33vw;
    width: 28.93vw;
    height: 20.93vw;
  }
}

.share-rewards-content-wrap .opt-box .left-btn {
  background: url("../../assets/images/big_btn_1.png") no-repeat 0 0;
  background-size: 28.93 * 4.2px 20.93 * 4.2px;
  margin-left: -1.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    background-size: 28.93vw 20.93vw;
    margin-left: -1.33vw;
  }
}

.share-rewards-content-wrap .opt-box .right-btn {
  background: url("../../assets/images/big_btn_2.png") no-repeat 0 0;
  background-size: 28.93 * 4.2px 20.93 * 4.2px;
  margin-right: -1.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    background-size: 28.93vw 20.93vw;
    margin-right: -1.33vw;
  }
}

.share-rewards-content-wrap .opt-box .middle-box {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.share-rewards-content-wrap .opt-box .middle-box .bi {
  width: 6.53 * 4.2px;
  height: 6 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 6.53vw;
    height: 6vw;
  }
}

.share-rewards-content-wrap .level-show-box {
  width: 94.67 * 4.2px;
  height: 6.93 * 4.2px;
  background: url("../../assets/images/number_show_bg.png") no-repeat 0 0;
  background-size: 94.67 * 4.2px 6.93 * 4.2px;
  margin-top: 1.07 * 4.2px;
  margin-bottom: 1.87 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  font-size: 3.33 * 4.2px;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  position: relative;
  z-index: 10;

  @media only screen and (max-width: 430px) {
    width: 94.67vw;
    height: 6.93vw;
    background-size: 94.67vw 6.93vw;
    font-size: 3.33vw;
    margin-top: 1.07vw;
    margin-bottom: 1.87vw;
  }
}

.share-rewards-content-wrap .level-show-box .col {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  margin-top: 1.07 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  color: #c7d4ff;

  @media only screen and (max-width: 430px) {
    margin-top: 1.07vw;
  }
}

.share-rewards-content-wrap .level-show-box .col.col-1 {
  width: 43.47 * 4.2px;
  padding-left: 3.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    padding-left: 2.07vw;
    width: 43.47vw;
  }
}

.share-rewards
  .share-rewards-content-wrap
  .level-show-box
  .col.col-1
  .col-text {
  width: 26.67 * 4.2px;
  height: auto;
  white-space: nowrap;

  @media only screen and (max-width: 430px) {
    width: 26.67vw;
  }
}

.share-rewards-content-wrap .level-show-box .col.col-2 {
  width: 47.87 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 47.87vw;
  }
}

.share-rewards
  .share-rewards-content-wrap
  .level-show-box
  .col.col-2
  .col-text {
  width: 32 * 4.2px;
  height: auto;
  white-space: nowrap;

  @media only screen and (max-width: 430px) {
    width: 32vw;
  }
}

.share-rewards
  .share-rewards-content-wrap
  .level-show-box
  .col.col-2
  .desc-btn {
  margin-left: 1.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-left: 1.33vw;
  }
}

.share-rewards-content-wrap .level-show-box .col .vip-text {
  color: #ffc53a;
}

.share-rewards-content-wrap .level-show-box .col .desc-btn {
  width: 11.07 * 4.2px;
  height: 5.87 * 4.2px;
  text-align: center;
  line-height: 5.87 * 4.2px;
  background: url("../../assets/images/k3.png") no-repeat 0 0;
  background-size: 11.07 * 4.2px 5.87 * 4.2px;
  font-size: 3.33 * 4.2px;
  color: #ffffff;
  margin-left: 3.87 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 11.07vw;
    height: 5.87vw;
    background-size: 11.07vw 5.87vw;
    font-size: 3.33vw;
    margin-left: 3.87vw;
  }
}

.share-rewards-content-wrap .table-content-wrap {
  width: 94.67 * 4.2px;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin: 0 2.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  background: url("../../assets/images/k4.png") no-repeat top center / 100% 9.07 *
      4.2px,
    url("../../assets/images/k5.png") no-repeat top 9.07 * 4.2px center / 100% -webkit-calc(100% -
          17.07 * 4.2px),
    url("../../assets/images/k6.png") no-repeat bottom center / 100% 8 * 4.2px;
  background: url("../../assets/images/k4.png") no-repeat top center / 100% 9.07 *
      4.2px,
    url("../../assets/images/k5.png") no-repeat top 9.07 * 4.2px center / 100%
      calc(100% - 17.07 * 4.2px),
    url("../../assets/images/k6.png") no-repeat bottom center / 100% 8 * 4.2px;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 94.67vw;
    margin: 0 2.67vw;
    background: url("../../assets/images/k4.png") no-repeat top center / 100%
        9.07vw url("../../assets/images/k5.png") no-repeat top 9.07vw center /
        100% -webkit-calc(100% - 17.07vw),
      url("../../assets/images/k6.png") no-repeat bottom center / 100% 8vw;
    background: url("../../assets/images/k4.png") no-repeat top center / 100%
        9.07 * 4.2px,
      url("../../assets/images/k5.png") no-repeat top 9.07vw center / 100%
        calc(100% - 17.07vw),
      url("../../assets/images/k6.png") no-repeat bottom center / 100% 8vw;
  }
}

.share-rewards-content-wrap .table-content-wrap:after {
  content: "";
  display: block;
  width: 94.67 * 4.2px;
  height: 5.47 * 4.2px;
  background: url("../../assets/images/srcoll_box_bottom_line.png") no-repeat
    center 0;
  background-size: 94.53 * 4.2px 5.47 * 4.2px;
  position: absolute;
  left: 0;
  bottom: 0;

  @media only screen and (max-width: 430px) {
    width: 94.67vw;
    height: 5.47vw;
    background-size: 94.53vw 5.47vw;
  }
}

.share-rewards-content-wrap .table-content-wrap .table-header {
  width: 94.67 * 4.2px;
  height: 26.67 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 3.2 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 94.67vw;
    height: 26.67vw;
    padding: 0 3.2vw;
  }
}

.share-rewards-content-wrap .table-content-wrap .table-header .total-box {
  width: 85.33 * 4.2px;
  height: 6.67 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #c7d4ff;
  font-size: 3.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 auto;

  @media only screen and (max-width: 430px) {
    width: 85.33vw;
    height: 6.67vw;
    font-size: 3.33vw;
  }
}

.share-rewards-content-wrap .table-content-wrap .table-header .total-box .col {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .total-box
  .col-1 {
  width: 45.33 * 4.2px;
  height: 6.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 45.33vw;
    height: 6.67vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .total-box
  .col-2 {
  width: 41.33 * 4.2px;
  height: 6.67 * 4.2px;
  padding-left: 6.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 41.33vw;
    height: 6.67vw;
    padding-left: 6.67vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .total-box
  .price {
  color: #ffdf9b;
  margin-left: 1.33 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  @media only screen and (max-width: 430px) {
    margin-left: 1.33vw;
  }
}

.share-rewards-content-wrap .filter-tab-box {
  width: 100%;
}

.share-rewards-content-wrap .filter-tab-box .tab-filter-box {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: 3.33 * 4.2px;
  color: #ffffff;
  line-height: 3.81 * 4.2px;
  text-align: center;
  font-style: normal;
  text-transform: none;

  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;

  @media only screen and (max-width: 430px) {
    font-size: 3.33vw;
    line-height: 3.81vw;
  }
}

.share-rewards-content-wrap .filter-tab-box .tab-filter-box .tab-item {
  width: 18.26 * 4.2px;
  height: 7.28 * 4.2px;
  background: url("../../assets/image3/share/notSelectedBack.png") no-repeat 0 0;
  background-size: 18.26 * 4.2px 7.28 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 2.4 * 4.2px;
  color: #7a7a7a;

  @media only screen and (max-width: 430px) {
    width: 18.26vw;
    height: 7.28vw;
    background-size: 18.26vw 7.28vw;
    margin-right: 2.4vw;
  }
}

.share-rewards-content-wrap .filter-tab-box .tab-filter-box .tab-item.sel {
  background: url("../../assets/image3/share/selectBack.png") no-repeat 0 0;
  background-size: 18.26 * 4.2px 7.28 * 4.2px;
  color: #ffffff;

  @media only screen and (max-width: 430px) {
    background-size: 18.26vw 7.28vw;
  }
}

.share-rewards-content-wrap .table-content-wrap .table-header .filter-box {
  width: 100%;
  height: 9.33 * 4.2px;
  margin-top: 1.33 * 4.2px;
  overflow: hidden;

  @media only screen and (max-width: 430px) {
    margin-top: 1.33vw;
    height: 9.33vw;
    width: 100vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .date-filter-box {
  width: auto;
  height: 9.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  float: left;

  @media only screen and (max-width: 430px) {
    height: 9.33vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .date-filter-box
  .date-item {
  width: 21.07 * 4.2px;
  height: 9.33 * 4.2px;
  background: url("../../assets/images/tab_short.png") no-repeat 0 0;
  background-size: 21.07 * 4.2px 9.33 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 2.4 * 4.2px;
  color: #7a7a7a;

  @media only screen and (max-width: 430px) {
    width: 21.07vw;
    height: 9.33vw;
    background-size: 21.07vw 9.33vw;
    margin-right: 2.4vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .date-filter-box
  .date-item.sel {
  background: url("../../assets/images/tab_short_active.png") no-repeat 0 0;
  background-size: 21.07 * 4.2px 9.33 * 4.2px;
  color: #ffffff;

  @media only screen and (max-width: 430px) {
    background-size: 21.07vw 9.33vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .search-box {
  width: 40 * 4.2px;
  height: 8 * 4.2px;
  float: right;
  background: url("../../assets/images/search_box_bg.png") no-repeat 0 0;
  background-size: 40 * 4.2px 8 * 4.2px;
  margin: 0.67 * 4.2px 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;

  @media only screen and (max-width: 430px) {
    width: 40vw;
    height: 8vw;
    background-size: 40vw 8vw;
    margin: 0.67vw 0;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .search-box
  .input-box {
  width: 30.67 * 4.2px;
  height: 8 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 30.67vw;
    height: 8vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .search-box
  .input-box
  input {
  width: 100%;
  height: 8 * 4.2px;
  background: transparent;
  text-align: center;
  font-size: 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 8vw;
    font-size: 2.67vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .search-box
  .input-box
  input::-webkit-input-placeholder {
  color: #9e9e9e;
  font-size: 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 2.67vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .search-box
  .input-box
  input::-moz-placeholder {
  color: #9e9e9e;
  font-size: 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 2.67vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .search-box
  .input-box
  input::-ms-input-placeholder {
  color: #9e9e9e;
  font-size: 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 2.67vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .search-box
  .input-box
  input::placeholder {
  color: #9e9e9e;
  font-size: 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 2.67vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .search-box
  .search-btn {
  width: 9.33 * 4.2px;
  height: 8 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;

  @media only screen and (max-width: 430px) {
    width: 9.33vw;
    height: 8vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-header
  .filter-box
  .search-box
  .search-btn
  image {
  width: 6.67 * 4.2px;
  height: 6.27 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 6.67vw;
    height: 6.27vw;
  }
}

.share-rewards-content-wrap .table-box {
  height: 26rem;
  background: #000000;
  border-radius: 8px;
  margin-top: 3.57 * 4.2px;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 400;
  font-size: 2.86 * 4.2px;
  color: #ffffff;
  background: linear-gradient(320deg, #05164e 0%, #0b2db4 100%);
  border: 1px solid;
  border-image: linear-gradient(
      96deg,
      rgba(179, 223, 255, 1),
      rgba(48, 168, 255, 0),
      rgba(172, 220, 255, 1)
    )
    1 1;
  // @media only screen and (max-width: 430px) {
  //   height: 86.2vw;
  //   margin-top: 3.57vw;
  //   font-size: 2.86vw;
  // }
}

.share-rewards-content-wrap .table-box .list-header {
  height: 9.05 * 4.2px;
  line-height: 9.05 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  background: #09183e;
  color: #c7d4ff;

  @media only screen and (max-width: 430px) {
    height: 9.05vw;
    line-height: 9.05vw;
  }
}

.share-rewards-content-wrap .table-box .table-scroll-box {
  height: calc(100vh - 230px);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  @media only screen and (max-width: 430px) {
    height: calc(100vh - 230px);
  }
}

.share-rewards-content-wrap .table-box .table-scroll-box .td-item {
  height: 9.05 * 4.2px;
  line-height: 9.05 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  color: #c7d4ff;

  @media only screen and (max-width: 430px) {
    height: 9.05vw;
    line-height: 9.05vw;
  }
}

.share-rewards-content-wrap
  .table-box
  .table-scroll-box
  .td-item:nth-child(2n + 1) {
  background: #101668;
}

.share-rewards-content-wrap
  .table-box
  .table-scroll-box
  .td-item:nth-child(2n) {
  background: #09183e;
}

.share-rewards-content-wrap .table-box .table-scroll-box .td-item .time {
  width: 18 * 4.2px;
  word-break: break-all;
  line-height: 4.76 * 4.2px;
  text-align: left;

  @media only screen and (max-width: 430px) {
    width: 18vw;
    line-height: 4.76vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-scroll-box
  .td-item:after {
  content: "";
  display: block;
  width: 88.27 * 4.2px;
  height: 0.4 * 4.2px;
  background: url("../../assets/images/line1.png") no-repeat center 0;
  background-size: 88.13 * 4.2px 0.4 * 4.2px;
  position: absolute;
  left: 0;
  bottom: 0;

  @media only screen and (max-width: 430px) {
    width: 88.27vw;
    height: 0.4vw;
    background-size: 88.13vw 0.4vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-scroll-box
  .td-item
  > div {
  text-align: center;
  font-size: 3.33 * 4.2px;
  color: #c7d4ff;

  @media only screen and (max-width: 430px) {
    font-size: 3.33vw;
  }
}

.share-rewards-content-wrap .table-content-wrap .table-scroll-box .td-item .id {
  width: 19.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 19.33vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-scroll-box
  .td-item
  .time {
  width: 30 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 30vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-scroll-box
  .td-item
  .price-1 {
  width: 20 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 20vw;
  }
}

.share-rewards-content-wrap
  .table-content-wrap
  .table-scroll-box
  .td-item
  .price-2 {
  width: 18.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 18.67vw;
  }
}

.team-detail .filter-box {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 6.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-top: 6.67vw;
  }
}

.team-detail .filter-box .filter-item {
  width: 38.4 * 4.2px;
  height: 9.33 * 4.2px;
  line-height: 9.33 * 4.2px;
  background: url("../../assets/images/new_ch_tab_bg1.png") no-repeat 0 0;
  background-size: 38.4 * 4.2px 9.33 * 4.2px;
  color: #7a7a7a;
  text-align: center;
  font-size: 4.4 * 4.2px;
  margin: 0 3.07 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 38.4vw;
    height: 9.33vw;
    line-height: 9.33vw;
    font-size: 4.4vw;
    margin: 0 3.07vw;
  }
}

.team-detail .filter-box .filter-item.sel {
  background: url("../../assets/images/new_ch_tab_bg2.png") no-repeat 0 0;
  background-size: 38.4 * 4.2px 9.33 * 4.2px;
  color: #ffffff;

  @media only screen and (max-width: 430px) {
    background-size: 38.4vw 9.33vw;
  }
}

.team-detail .search-box {
  width: 79.73 * 4.2px;
  height: 7.73 * 4.2px;
  background: url("../../assets/images/k8.png") no-repeat 0 0;
  background-size: 79.73 * 4.2px 7.73 * 4.2px;
  margin: 2.67 * 4.2px auto;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 79.73vw;
    height: 7.73vw;
    background-size: 79.73vw 7.73vw;
    margin: 2.67vw auto;
  }
}

.team-detail .search-box input {
  width: 69.33 * 4.2px;
  height: 7.73 * 4.2px;
  line-height: 7.73 * 4.2px;
  text-align: center;
  background: transparent;
  font-size: 3.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 69.33vw;
    height: 7.73vw;
    line-height: 7.73vw;
    font-size: 3.33vw;
  }
}

.team-detail .search-box input::-webkit-input-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 3.33vw;
  }
}

.team-detail .search-box input::-moz-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 3.33vw;
  }
}

.team-detail .search-box input::-ms-input-placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 3.33vw;
  }
}

.team-detail .search-box input::placeholder {
  color: #a6bbff;
  font-size: 3.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    font-size: 3.33vw;
  }
}

.team-detail .search-box .search-btn {
  width: 9.07 * 4.2px;
  height: 7.73 * 4.2px;
  background: url("../../assets/images/search-icon.png") no-repeat center center;
  background-size: 6.67 * 4.2px 6.27 * 4.2px;
  position: absolute;
  top: 0;
  right: 1.33 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 6.67vw;
    height: 6.27vw;
    background-size: 6.67vw 6.27vw;
    top: 0;
    right: 1.33vw;
  }
}

.team-detail .table-box-wrap {
  width: 94.53 * 4.2px;
  height: 85.73 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 auto 12.27 * 4.2px auto;
  padding: 0 3.07 * 4.2px 0 3.2 * 4.2px;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 94.53vw;
    height: 85.73vw;
    margin: 0 auto 12.27vw auto;
    padding: 0 3.07vw 0 3.2vw;
  }
}

.team-detail .table-box-wrap:after {
  content: "";
  display: block;
  width: 94.53 * 4.2px;
  height: 5.47 * 4.2px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: url("../../assets/images/table_bottom_shadow_bgpng.png") no-repeat
    0 0;
  background-size: 94.53 * 4.2px 5.47 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 94.53vw;
    height: 5.47vw;
    background-size: 94.53vw 5.47vw;
  }
}

.team-detail .table-box-wrap .table-header {
  width: 88.4 * 4.2px;
  height: 7.47 * 4.2px;
  background: url("../../assets/images/table_header_bg.png") no-repeat 0 0;
  background-size: 88.27 * 4.2px 7.47 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 88.4vw;
    height: 7.47vw;
    background-size: 88.27vw 7.47vw;
  }
}

.team-detail .table-box-wrap .table-header .item-td {
  width: 21.76 * 4.2px;
  height: 7.47 * 4.2px;
  line-height: 7.47 * 4.2px;
  text-align: center;
  margin-right: 0.4 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;

  @media only screen and (max-width: 430px) {
    width: 88.4vw;
    height: 7.47vw;
    line-height: 7.47vw;
    margin-right: 0.4vw;
  }
}

.team-detail .table-box-wrap .table-header .item-td:last-child {
  margin-right: 0;
}

.team-detail .table-box-wrap .table-content {
  width: 88.27 * 4.2px;
  height: 78.27 * 4.2px;
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 5.47 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 88.27vw;
    height: 78.27vw;
    padding-bottom: 5.47vw;
  }
}

.team-detail .table-box-wrap .table-content .t-row {
  width: 88.27 * 4.2px;
  height: 7.73 * 4.2px;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;

  @media only screen and (max-width: 430px) {
    width: 88.27vw;
    height: 7.73vw;
  }
}

.team-detail .table-box-wrap .table-content .t-row:after {
  content: "";
  display: block;
  width: 88.27 * 4.2px;
  height: 1px;
  position: absolute;
  left: 0;
  bottom: 0;
  background: url("../../assets/images/line2.png") no-repeat 0 0;
  background-size: 88.27 * 4.2px 1px;

  @media only screen and (max-width: 430px) {
    width: 88.27vw;
    height: 1px;
    background-size: 88.27vw 1px;
  }
}

.team-detail .table-box-wrap .table-content .list-item-td {
  width: 21.76 * 4.2px;
  height: 7.73 * 4.2px;
  line-height: 10.4 * 4.2px;
  text-align: center;

  @media only screen and (max-width: 430px) {
    width: 21.76vw;
    height: 7.73vw;
    line-height: 10.4vw;
  }
}

.rewards-rule-dialog .rewards-rule-content {
  width: 100%;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-top: 2.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    padding-top: 2.67vw;
  }
}

.rewards-rule-dialog .rewards-rule-content .row-title {
  width: 100%;
  height: 5.47 * 4.2px;
  background: url("../../assets/images/title_bg.png") no-repeat 8.53 * 4.2px 0;
  background-size: 43.07 * 4.2px 5.47 * 4.2px;
  padding-left: 8.53 * 4.2px;
  padding-top: 0.67 * 4.2px;
  float: left;

  @media only screen and (max-width: 430px) {
    height: 5.47vw;
    background-size: 43.07vw 5.47vw;
    padding-left: 8.53vw;
    padding-top: 0.67vw;
  }
}

.rewards-rule-dialog .rewards-rule-content .row-title.title-2 {
  margin-top: 1.47 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-top: 1.47vw;
  }
}

.rewards-rule-dialog .rewards-rule-content .row-content {
  padding-top: 1.47 * 4.2px;
  padding-left: 8.53 * 4.2px;
  width: 100%;
  font-size: 2.67 * 4.2px;
  color: #a6bbff;

  @media only screen and (max-width: 430px) {
    padding-top: 1.47vw;
    padding-left: 8.53vw;
    font-size: 2.67vw;
  }
}

.rewards-rule-dialog .rewards-rule-content .row-content p {
  width: 100%;
  height: 4.27 * 4.2px;
  line-height: 4.27 * 4.2px;

  @media only screen and (max-width: 430px) {
    line-height: 4.27vw;
    height: 4.27vw;
  }
}

.rewards-rule-dialog .rewards-rule-content .vip-level-table {
  width: 90.4 * 4.2px;
  height: auto;
  padding-top: 10.67 * 4.2px;
  margin-top: 2.67 * 4.2px;
  margin-left: 4.8 * 4.2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-bottom: 9.07 * 4.2px;
  color: #a6bbff;
  background: url("../../assets/images/table-bg.png") no-repeat 0 2 * 4.2px;
  background-size: 90.4 * 4.2px -webkit-calc(100% - 6.67 * 4.2px);
  background-size: 90.4 * 4.2px calc(100% - 6.67 * 4.2px);
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 90.4vw;
    height: auto;
    padding-top: 10.67vw;
    margin-top: 2.67vw;
    margin-left: 4.8vw;

    padding-bottom: 9.07vw;
    background: url("../../assets/images/table-bg.png") no-repeat 0 2vw;
    background-size: 90.4vw -webkit-calc(100% - 6.67vw);
    background-size: 90.4vw calc(100% - 6.67vw);
  }
}

.share-rewards
  .rewards-rule-dialog
  .rewards-rule-content
  .vip-level-table::after {
  content: "";
  width: 84.4 * 4.2px;
  height: 5.47 * 4.2px;
  position: absolute;
  left: 2.93 * 4.2px;
  top: 1.33 * 4.2px;
  background: url("../../assets/images/table_header_bg2.png") no-repeat 0 0;
  background-size: 84.4 * 4.2px 5.47 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 84.4vw;
    height: 5.47vw;
    left: 2.93vw;
    top: 1.33vw;
    background-size: 84.4vw 5.47vw;
  }
}

.rewards-rule-dialog .rewards-rule-content .table-header {
  width: 90.4 * 4.2px;
  height: 7.6 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  line-height: 7.6 * 4.2px;
  position: relative;

  @media only screen and (max-width: 430px) {
    width: 90.4vw;
    height: 7.6vw;
    line-height: 7.6vw;
  }
}

.rewards-rule-dialog .rewards-rule-content .table-header image {
  position: absolute;
  top: -6.67 * 4.2px;
  left: 38.67 * 4.2px;
  width: 13.2 * 4.2px;
  height: 4.8 * 4.2px;

  @media only screen and (max-width: 430px) {
    width: 13.2vw;
    height: 4.8vw;
    top: -6.67vw;
    left: 38.67vw;
  }
}

.rewards-rule-dialog .rewards-rule-content .level {
  width: 46.4 * 4.2px;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-left: 0px;
  text-align: center;

  @media only screen and (max-width: 430px) {
    width: 13.2vw;
  }
}

.rewards-rule-dialog .rewards-rule-content .reward-percent {
  width: 44 * 4.2px;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;

  @media only screen and (max-width: 430px) {
    width: 44vw;
  }
}

.rewards-rule-dialog .rewards-rule-content .table-content {
  width: 100%;
  height: auto;
}

.share-rewards
  .rewards-rule-dialog
  .rewards-rule-content
  .table-content
  .table-row {
  width: 100%;
  height: 5.87 * 4.2px;
  line-height: 5.87 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  background: url("../../assets/images/k9.png") no-repeat 2.67 * 4.2px 0;
  background-size: 84 * 4.2px 5.87 * 4.2px;

  @media only screen and (max-width: 430px) {
    height: 5.87vw;
    line-height: 5.87vw;
    background: url("../../assets/images/k9.png") no-repeat 2.67vw 0;
    background-size: 84vw 5.87vw;
  }
}

.share-rewards
  .rewards-rule-dialog
  .rewards-rule-content
  .table-content
  .table-row
  > div {
  position: relative;
  z-index: 10;
}

.share-rewards
  .rewards-rule-dialog
  .rewards-rule-content
  .table-content
  .table-row.sel {
  color: #fff;
  font-weight: bold;
}

.share-rewards
  .rewards-rule-dialog
  .rewards-rule-content
  .table-content
  .table-row.sel
  .level {
  margin-top: 0.67 * 4.2px;

  @media only screen and (max-width: 430px) {
    margin-top: 0.67vw;
  }
}

.share-rewards
  .rewards-rule-dialog
  .rewards-rule-content
  .table-content
  .table-row.sel:before {
  content: "";
  display: block;
  width: 90.4 * 4.2px;
  height: 6 * 4.2px;
  position: absolute;
  left: 0;
  background: url("../../assets/images/table_row_sel.png") no-repeat 2.67 *
    4.2px 0;
  background-size: 84 * 4.2px 6 * 4.2px;
  z-index: 8;

  @media only screen and (max-width: 430px) {
    width: 90.4vw;
    height: 6vw;
    background: url("../../assets/images/table_row_sel.png") no-repeat 2.67vw 0;
    background-size: 84vw 6vw;
  }
}

.dialog-area .common-small-dialog-content {
  width: 100% !important;

  @media only screen and (max-width: 430px) {
    width: 100vw !important;
  }
}
</style>